// extracted by mini-css-extract-plugin
export default {"container":"CardAuthor_container__7ZWHE","description":"CardAuthor_description__Wy7Ok"};